/** @format */

import React, { Component } from 'react';
import intl from 'react-intl-universal';
import { connect } from 'react-redux';
import FileDownload from 'src/ui/library/FileDownload';
import { downloadXMLFile, reassignCase } from 'src/services/cms.service.js';
import serviceUrls from 'src/constants/serviceUrls';
// import { getPlatform } from 'src/helpers';
import iconTransform from 'src/helpers/iconTransform.js';
import { showNotification } from 'src/utils/utilsActions';
import Button from 'src/ui/library/Button';

class DownloadControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSpinner: false,
    };
    this.onDownload = this.onDownload.bind(this);
  }

  onDownload = (setFileData, setStatus) => {
    // let deviceOS = getPlatform();
    // if (deviceOS === "Browser"){
    this.setState({ showSpinner: true });
    // }

    // setStatus(true);
    downloadXMLFile({ elementName: this.props.id }).then(res => {
      // success scenario
      let isSyncToCCH = this.props.id.endsWith('US_SyncToCCH');
      if (res && res.success) {
        if (isSyncToCCH) {
          this.props.showNotification(res.message, { variant: 'success' });
        } else {
          setFileData(res.attachmentData, res.fileName);
        }
        this.setState({ showSpinner: false });
      }

      // failure scenario
      if (!res || res.success === false) {
        // if (deviceOS === "Browser"){
        this.setState({ showSpinner: false });
        // }
        //setStatus(false);
      }
    });
  };

  getPdfUrl = () => {
    const { downloadPDFDocument } = this.props;
    const token = sessionStorage.getItem('token');
    const userID = sessionStorage.getItem('userProfile');
    return `${serviceUrls.CMS_XML_DOWNLOAD}?goPDFId=${
      downloadPDFDocument ? downloadPDFDocument.goPDFId : null
    }&token=${token}&userId=${userID}&cordova=1&cordovaaction=download&download=pdfFileData`;
  };

  handleAction = action => {
    this.setState({ showSpinner: true });
    if (action === 'ReassignCaseButton') {
      reassignCase()
        .then(res => {
          if (res.success) {
            if (res.message) {
              const variant = res.success ? 'success' : 'error';
              this.props.showNotification(res.message, { variant });
              this.setState({ showSpinner: false });
            } else {
              const messages = res.multiple;
              const primaryMessage = messages[0];
              const secondaryMessage = messages[1];
              setTimeout(() => {
                this.props.showNotification(secondaryMessage.caseMessage, { variant: secondaryMessage.success ? 'success' : 'error' });
              }, 600);
              this.props.showNotification(primaryMessage.caseMessage, { variant: primaryMessage.success ? 'success' : 'error' });
              this.setState({ showSpinner: false });
            }
          } else {
            const variant = res.success ? 'success' : 'error';
            this.props.showNotification(res.message, { variant });
            this.setState({ showSpinner: false });
          }
        })
        .catch(error => {
          this.props.showNotification('Error', { variant: 'error' });
          this.setState({ showSpinner: false });
        });
    }
  };

  render() {
    const { label, align, icon, downloadPDFDocument, action } = this.props;
    const { showSpinner } = this.state;

    let deviceOS = 'Browser'; //getPlatform();
    let documentTypeString = 'contentparser.downloadPDF';
    if (downloadPDFDocument) {
      switch (downloadPDFDocument.fileExtensionName) {
        case 'xls':
        case 'xlsx':
          documentTypeString = 'contentparser.downloadExcel';
          break;
        case 'doc':
        case 'docx':
          documentTypeString = 'contentparser.downloadWord';
          break;
        default:
          documentTypeString = 'contentparser.downloadPDF';
          break;
      }
    }
    const alignClass = align === 'R' ? 'right-align' : align === 'C' ? 'center-align' : 'left-align';

    const renderButton = (
      <Button
        isLoading={showSpinner}
        styleType="tertiary"
        onClick={() => {
          this.handleAction(action);
        }}
        style={{
          minWidth: '180px',
        }}>
        {label}
      </Button>
    );
    return (
      <div className={`control-text flex-column ${alignClass}`}>
        {
          <div className={`control-wrapper ${align === 'C' ? 'justifyCenter' : ''}`}>
            {icon && <div className={'control-icons control-icons-inline'}>{iconTransform(icon)}</div>}
            <div className={'control-icons-inline-controls'}>
              {deviceOS === 'Browser' ? (
                <div>
                  {!action ? (
                    <FileDownload
                      label={label}
                      buttonLabel={intl.get(documentTypeString)}
                      onRequest={this.onDownload}
                      showSpinner={this.state.showSpinner}
                    />
                  ) : (
                    renderButton
                  )}
                </div>
              ) : (
                // let pdfUrl = this.getPdfUrl();
                <div>
                  {!action ? (
                    <FileDownload label={label} buttonLabel={intl.get(documentTypeString)} href={this.getPdfUrl()} showSpinner={false} />
                  ) : (
                    renderButton
                  )}
                </div>
              )}
            </div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = {
  showNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadControl);
